import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FutureIconContainer, LockedIcon, UserPlusIcon } from 'asterX-UI/Icons'
import { LoaderBackdrop } from 'asterX-UI/Loaders'
import { Grid, InputAdornment, LinearProgress } from '@material-ui/core'
import ActionModal from 'asterX-UI/Modals/ActionModal'
import StarsIcon from 'asterX-UI/Icons/StarsIcon'
import { AuthService } from 'lib/api'
import { useDebounce, useResErrors } from 'hooks'
import { AutoCompleteField } from 'asterX-UI/Inputs'
import { useProfileStore } from 'context/ProfileStore'

const namespace = 'profilePage.accessInTheSystem.copyAccessesModal.'
const CopyAccessesModal = ({ open = false, onClose = () => {} }) => {
  const { t } = useTranslation()
  const { standardCheck } = useResErrors()
  const {
    profileStoreFunc: { setRolesFromRoleList }
  } = useProfileStore()
  const [loading, setLoading] = useState({
    userList: false,
    save: false
  })
  const [userList, setUserList] = useState([])
  const [userId, setUserId] = useState(null)
  const [username, setUsername] = useState('')

  const debouncedSearchTerm = useDebounce(username, 500)

  const setLoader = (key, value) =>
    setLoading(prevState => ({ ...prevState, [key]: value }))

  const onChange = e => {
    const { name, value } = e.target
    setUserId(value)
  }
  useEffect(() => {
    if (debouncedSearchTerm) {
      getUsers()
    }

    return () => {}
  }, [debouncedSearchTerm])

  const getUsers = async () => {
    setLoader('userList', true)
    await AuthService.getUsers({
      username: debouncedSearchTerm,
      limit: 200
    }).then(res =>
      standardCheck(
        res,
        () => {
          setUserList(res.data?.userList || [])
          setLoader('userList', false)
        },
        {
          onFail: () => setLoader('userList', false),
          textErr: t(`${namespace}error.users`)
        }
      )
    )
  }

  const getRolesUser = async () => {
    setLoader('save', true)
    await AuthService.getRolesUserById(userId).then(res =>
      standardCheck(
        res,
        () => {
          setLoader('save', false)
          setRolesFromRoleList(res.data || [])
          onClose()
        },
        {
          onFail: () => setLoader('save', false),
          textErr: t(`${namespace}error.getUsersAccesses`)
        }
      )
    )
  }

  const onInputChange = (event, newInputValue) => {
    setUsername(newInputValue)
  }
  const handleSave = () => getRolesUser()
  return (
    <ActionModal
      open={open}
      color={'primary'}
      onClose={onClose}
      onCancel={onClose}
      onConfirm={handleSave}
      iconComponent={
        <FutureIconContainer color={'success'}>
          <StarsIcon />
        </FutureIconContainer>
      }
      title={t(namespace + 'copyFrom')}
      subtitle={t(namespace + 'subtitle')}
      labelConfirm={t(namespace + 'copy')}
      disableConfirm={!userId}
    >
      <Grid container spacing={2}>
        <LoaderBackdrop loading={loading.save} />
        <Grid item xs={12} md={12} lg={12} xl={12}>
          <AutoCompleteField
            name={'user'}
            value={userId}
            options={userList}
            onChange={onChange}
            labelKey={'username'}
            inputValue={username}
            valueKey={'id'}
            onInputChange={onInputChange}
            label={t(namespace + 'selectUser')}
            placeholder={t(namespace + 'selectUser')}
            InputProps={{
              startAdornment: (
                <InputAdornment position={'end'}>
                  <UserPlusIcon fontSize={'small'} />
                </InputAdornment>
              )
            }}
            fullWidth
            loading={loading.userList}
          />
        </Grid>
      </Grid>
    </ActionModal>
  )
}
export default CopyAccessesModal
